import logo from './logo.svg';
import './App.css';
import Signup from './Components/SignUp-SignIn/Signup';
import Home from './Components/Home/Home';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Signin from './Components/SignUp-SignIn/Signin';
import Dashboard from './Components/Dashboards/Dashboard';
import TestProduct from './Components/Dashboards/TestProduct';
import AboutUs from './Components/AboutUs/AboutUs';
import ContactUs from "./Components/ContactUs/ContactUs";
import Singinture from './Components/SignUp-SignIn/Singinture';
import CurierComfirm from './Components/SignUp-SignIn/CurierComfirm';
import BlogPage from './Components/BlogPage/BlogPage';
import Orders from './Components/OrderPage/Orders';
import SingleProduct from './Components/OrderPage/SingleProduct';
import CompanyPage from './Components/OrderPage/CompanyPage';
import CheckoutPage from './Components/OrderPage/CheckoutPage';
import { CartProvider } from './Components/OrderPage/CartContext';
import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, setDoc, onSnapshot } from 'firebase/firestore';
import { auth, db } from './Firebaseconfig';
import ErrorPage from './Components/ErrorPage/error';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubSnapshot = null;

    const unsubAuth = onAuthStateChanged(auth, async (user) => {
      // Clean up previous snapshot listener
      if (unsubSnapshot) {
        unsubSnapshot();
        unsubSnapshot = null;
      }

      if (user) {
        // Asynchronously update lastLogin
        setDoc(doc(db, 'users', user.uid), {
          lastLogin: new Date().toISOString()
        }, { merge: true }).catch((err) => {
          console.error("Failed to update lastLogin:", err);
        });

        // Set up active listener for the user doc
        unsubSnapshot = onSnapshot(doc(db, 'users', user.uid), (userSnap) => {
          if (userSnap.exists()) {
            setRole(userSnap.data().role || 'user');
          } else {
            setRole('user');
          }
          setLoading(false);
        }, (err) => {
          console.error("Failed to fetch user role:", err);
          setRole('user');
          setLoading(false);
        });
      } else {
        setRole(null);
        setLoading(false);
      }
    });

    return () => {
      unsubAuth();
      if (unsubSnapshot) {
        unsubSnapshot();
      }
    };
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#111111', color: '#8a8f9e', fontFamily: 'Inter,sans-serif', gap: 10 }}>
        Loading...
      </div>
    );
  }

  const isSpecialRole = role && ['company', 'merchant', 'carrier', 'courier'].includes(role.toLowerCase());

  return (
    <div className="App">
      <CartProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            {isSpecialRole ? (
              <>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </>
            ) : (
              <>
                <Route path="/signup" element={<Signup />} />
                <Route path="/login" element={<Signin />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/" element={<Home />} />
                <Route path="/test" element={<TestProduct />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/signature" element={<Singinture />} />
                <Route path="/courier-confirm" element={<CurierComfirm />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/products" element={<Orders />} />
                <Route path="/product/:id" element={<SingleProduct />} />
                <Route path="/company/:companyId" element={<CompanyPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="*" element={<ErrorPage />} />
              </>
            )}
          </Routes> 
        </Router>
      </CartProvider>
    </div>
  );
}

export default App;
